import "react-app-polyfill/ie11";
import React, { useState, useCallback } from "react";
import ReactDOM from "react-dom";
import Root from "./client_customizations/containers/Root/Root";
import { BrowserRouter as Router } from "react-router-dom";
import { IntlProvider, ReactIntlErrorCode } from "react-intl";
import * as serviceWorker from "./serviceWorker";
import "./utils/polyfills";
import messages_en from "./context/translations/en.js";
import messages_esp from "./context/translations/esp.js";

// Missing translations fall back to defaultMessage, so don't log them
const handleIntlError = (err) => {
  if (err.code === ReactIntlErrorCode.MISSING_TRANSLATION) {
    return;
  }
  console.error(err);
};

const DEFAULT_LANGUAGE = "EN";
const SUPPORTED_LANGUAGES = ["EN", "ES"];

// Read the persisted language once, before the first render, so a refresh
// never flashes the default language or triggers a second data fetch.
const getInitialLanguage = () => {
  try {
    const stored = localStorage.getItem("language");
    return SUPPORTED_LANGUAGES.includes(stored) ? stored : DEFAULT_LANGUAGE;
  } catch (e) {
    return DEFAULT_LANGUAGE;
  }
};

const App = () => {
  const [language, setLanguage] = useState(getInitialLanguage);
  const [messages] = useState({
    EN: messages_en,
    ES: messages_esp,
  });

  const changeLanguage = useCallback((lang) => {
    try {
      // Persist the newly selected language, not the previous one.
      localStorage.setItem("language", lang);
    } catch (e) {
      // Storage may be unavailable (private mode, quota); the UI still switches.
    }
    setLanguage(lang);
  }, []);


  return (
    <IntlProvider
      locale={language}
      messages={messages[language]}
      onError={handleIntlError}
    >
      <Router>
        <Root language={language} changeLanguage={changeLanguage} />
      </Router>
    </IntlProvider>
  );
};

const rootElement = document.getElementById("root");
ReactDOM.render(<App />, rootElement);

// ReactDOM.render(
//   <IntlProvider locale={language} messages={messages[language]}>
//     <Router>
//         <Root changeLanguage={changeLanguage}/>
//     </Router>
//   </IntlProvider>,
//   document.getElementById("root")
// );

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
